import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastContainerDirective } from 'ngx-toastr';

@Component({
  selector: 'wsb-page-preview-modal',
  templateUrl: './page-preview-modal.component.html',
  styleUrls: ['./page-preview-modal.component.scss'],
  standalone: false
})
export class PagePreviewModalComponent {
  @Input() public title = 'page_preview';
  @Input() public previewHtml;
  @Input() public labelCancelButton = 'common_cancel';
  @Input() public loading = false;
  @Input() public primaryDisabled = false;
  @Output() cancelEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

  constructor(public activeModal: NgbActiveModal) {}
}
